import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  Button,
} from 'alm-react-components';
import { t } from 'i18next';
import moment from 'moment-timezone';
import { useContext, useEffect, useState } from 'react';
import { LiveMeetingInt, Minutes } from '../../../assets/constants/constants';
import { analytics_category, analytics_event, analytics_label } from '../../../assets/constants/staticContentConstants.ts';
import { AppContext } from '../../../context/AppProvider';
import useGaEventTracking from '../../../hooks/UseGaEventTracking.tsx';

type WatchRecordingProps = {
  liveClassdateStart: any;
  completionDeadline: any;
  timeZoneCode: any;
  isRecordingAvail: any;
  gotToCourseDetailPage: any;
  weekId: any;
  courseId: any;
  course: any
  pId:any
  program:any
  currentQuarter:any
  recordingId:any;
};

export const WatchRecording = ({
  liveClassdateStart,
  completionDeadline,
  isRecordingAvail,
  gotToCourseDetailPage,
  weekId,
  courseId,
  course,
  pId,
  program,
  currentQuarter,
  recordingId
}: WatchRecordingProps) => {
  const [isStartMeating, setIsStartMeating] = useState<boolean>(false);
  const [showModal, setShowModal] = useState<boolean>(false);
  const gaEventTracker = useGaEventTracking();
  const { state } = useContext(AppContext);

  const liveClassdateStart_ = liveClassdateStart; //'2024-07-15T9:22:00.000Z';
  const completionDeadline_ = completionDeadline; //'2024-07-15T10:30:00.000Z';

  // const startTime = covertDateUtcToIST(liveClassdateStart_, timeZoneCode);
  // const endTime = covertDateUtcToIST(completionDeadline_, timeZoneCode);
  // const datetimenow = moment();
  // const formattedDate = datetimenow.toISOString()
  // const datetimeZone=covertDateUtcToIST(formattedDate, timeZoneCode);
  // const dateNow = datetimeZone.format(moment.HTML5_FMT.DATETIME_LOCAL);
  // const startBeforeFifteenMint = moment(startTime).subtract(LiveMeetingInt, Minutes);
  // const isBefore = moment(dateNow).isBefore(startTime?.format(moment.HTML5_FMT.DATETIME_LOCAL));

  // const isBetween = () => {
  //   const datetimeNow = moment();
  //   const formattedDateTime = datetimeNow.toISOString(); 
  //   const datetimeZone=covertDateUtcToIST(formattedDateTime, timeZoneCode);
  //   return moment(datetimeZone.format(moment.HTML5_FMT.DATETIME_LOCAL)).isBetween(
  //     startBeforeFifteenMint?.format(moment.HTML5_FMT.DATETIME_LOCAL),
  //     endTime?.format(moment.HTML5_FMT.DATETIME_LOCAL)
  //   );
  // };
  const startTime = moment(new Date(liveClassdateStart_)).utc().toDate() //original API response
  const endTime = moment(new Date(completionDeadline_)).utc().toDate()//original API response
  const startTimeLocal = moment(new Date(startTime)); //convert startTimeUTC to local timezone and use for display

  const currentUTCtime = moment.utc().toDate() //Current UTC time
  
  const isBefore = moment(currentUTCtime).isBefore(startTime);
  const isBetween = () => {
    // return moment(moment().format(moment.HTML5_FMT.DATETIME_LOCAL)).isBetween(
    //   startBeforeFifteenMint?.format(moment.HTML5_FMT.DATETIME_LOCAL),
    //   endTime?.format(moment.HTML5_FMT.DATETIME_LOCAL)
    // );
    const currentUTCtime = moment.utc().toDate() //Current UTC time
    const startBeforeFifteenMint = moment(startTime).subtract(LiveMeetingInt, Minutes).utc().toDate();//startTimeUTC - 15 mins
    return moment(currentUTCtime).isBetween(startBeforeFifteenMint,endTime);
  };
  const isBetweenTime = isBetween();

  const checkMeating = () => {
   const intervalId= setInterval(() => {
      setIsStartMeating(isBetween());
    }, 500);
    return intervalId
  };

  useEffect(() => {
   const  intervalId=checkMeating();
   return ()=>{
    clearInterval(intervalId)
   }
  }, []);
  const checkRecording = (weekId: string, courseId: string) => {
    if (isRecordingAvail) {
      const items = {
        value: null,
        currency: null,
        transaction_id: null,
        items: [{}],
        userId:state.user?.userId,
        program_name:program,
        program_id:pId,
        program_quarter:`${currentQuarter.quarter}-${currentQuarter.year}`,
        recording_id:recordingId,
        recording_name:course,
        timeStamp: new Date()
    };
  
  gaEventTracker(analytics_event.watchRecording,analytics_category.buttonclickWatchReacording,analytics_label.watchRecordingLable,items);
      gotToCourseDetailPage(weekId, courseId);
    } else {
      setShowModal(true);
    }
  };
  
  return (
    <>
      {showModal && (
        <AlertDialog open={true}>
          <AlertDialogContent className="bg-[#16171C] py-6 px-3 max-md:px-6 md:px-6 w-full text-center border border-primary overflow-hidden">
            <AlertDialogDescription className="text-sm text-muted-foreground flex max-sm:h-40 md:h-24 flex-col">
              <div className="text-xl font-barlowRegular z-[1] text-white">
                <span dangerouslySetInnerHTML={{ __html: t(`Program.noWatchRecording`) }} />
              </div>
            </AlertDialogDescription>
            <AlertDialogFooter className="lg:justify-center z-[1]">
              <AlertDialogAction
                onClick={() => setShowModal(false)}
                className="w-full font-opensansSemiBold text-base capitalize"
              >
                {' '}
                <span dangerouslySetInnerHTML={{ __html: t('Common.gotIt') }} />
              </AlertDialogAction>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialog>
      )}
      <div className="min-w-0 flex-1">
        <div className="font-opensansMedium text-base">
          {<span dangerouslySetInnerHTML={{ __html: t('Common.dataAndTime') }} />} :{' '}
          <span className="text-primary">
            <span className="capitalize">
            {startTimeLocal?.format("MMM. DD, HH:mm").replace("..", ".")}
            </span>
          </span>
        </div>
        <div className=""><span dangerouslySetInnerHTML={{ __html: t('Program.recordingMessage') }} /></div>
      </div>
      <div className="flex lg:ml-4">
        {isBetweenTime || isBefore ? (
          <Button
            variant={'default'}
            className=" font-opensansBold text-sm dark:bg-white relative"
            onClick={() => {
              gotToCourseDetailPage(weekId, courseId)
            }
        }
          >
            <span
              className={`w-[8px] h-[8px] rounded-full ${
                isStartMeating ? 'bg-red-500 circle mr-3' : null
              }   mt-2`}
            ></span>
             <span dangerouslySetInnerHTML={{ __html: isBetweenTime || isBefore ? t('Common.joinLiveMeeting') : t('Common.watchRecording')}} />
          </Button>
        ) : liveClassdateStart_ ? (
          <Button
            variant={'default'}
            className=" font-opensansBold text-sm dark:bg-white relative"
            onClick={() => checkRecording(weekId, courseId)}
          >
            {' '}
            <span dangerouslySetInnerHTML={{ __html: t('Common.watchRecording') }} />
          </Button>
        ) : null}
      </div>
    </>
  );
};
